import { GzReportingPeriodWebComponent } from './component/GzReportingPeriodWebComponent';

export { GzReportingPeriodWebComponent };
